import React from 'react';
import { Accordion } from '@sravni/react-design-system/lib/Accordion';
import cn from 'classnames';
import styles from './styles.module.scss';

type ItemProps = React.ComponentProps<typeof Accordion.Item>;

export const AccordionItem: React.FunctionComponent<ItemProps> = (props) => {
    const { children, className, ...otherProps } = props;

    return (
        <Accordion.Item {...otherProps} className={cn([styles['accordion-item']], className)}>
            {children}
        </Accordion.Item>
    );
};
